import React from 'react';

import { useBreakpoint } from '$hooks/events';
import { Image } from '$partials/media';
import { Tag } from '$partials/ui';
import { formatPrice, formatTagBanner } from '$utilities/format';
import OffMarketBox from './off-market-box.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/listings').RentalPropertyItem}
 */
const RentalProperty = (props) => {
    const {
        rentGbp,
        rentFrequency,
        heading,
        propertyName,
        area,
        outwardCode,
        url,
        listingMedia,
        publicSellingStatus,
        parentPageType,
        offMarket,
        statusTag
    } = props;
    const breakpoint = useBreakpoint([ 'main', 'sm', 'md' ], 'main');
    const image = listingMedia?.[0]?.image;

    const formatRentFrequency = (frequency) => {
        switch(frequency){
            case 'WEEKLY':
                return 'p/w';
            case 'MONTHLY':
                return 'p/m';
            case 'ANNUALLY':
                return 'p/y';
            default:
                return;
        }
    };

    if (offMarket) {
        return <OffMarketBox {...props}/>;
    }

    return (
        <>
            <div className='px5 md-px6 pt5 pb5 md-pb8'>
                {parentPageType !=='LetPropertyListingPage' && (
                    <div className='absolute top-0 mt5 z2'>
                        <Tag
                            title={formatTagBanner(publicSellingStatus, statusTag)}/>
                    </div>
                )}
                <div style={{fontSize: '377px'}}>
                    <div style={{
                        height: breakpoint === 'md' ? '377px' : 'auto',
                        width: breakpoint === 'md' ? `${(image?.width / image?.height)}em` : '280px',
                        maxWidth: '100%'
                    }}>
                        {image && <Image {...image}/>}
                    </div>
                </div>
                <div className='flex flex-col md-flex-row col-12 black pt5 md-pt8'>
                    <div className='md-col-4 pr6 flex-col'>
                        <p className='type-style-5 pb3'>
                            {formatPrice(rentGbp)}{' '}{formatRentFrequency(rentFrequency)}
                        </p>
                        <div className='hide md-show'>
                            <p className='type-style-5'>{propertyName}</p>
                            <p className='type-style-5'>{area}{' '}{outwardCode}</p>
                        </div>
                    </div>
                    <div className='md-col-8 pr10 flex-grow'>
                        <h3 className='type-style-3'>{heading}</h3>
                    </div>
                    <div className='md-hide pt5'>
                        <p className='type-style-5'>{propertyName}</p>
                        <p className='type-style-5'>{area}{' '}{outwardCode}</p>
                    </div>
                </div>
                <a
                    className='link-reset expand-interaction__action'
                    href={url}>
                </a>
            </div>

        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

RentalProperty.__typename = 'RentalPropertyPage';

export default RentalProperty;
